import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'; // Assuming you have a CSS file for styling

const Navbar: React.FC = () => {
    return (
        <nav className="navbar">
            <div className="navbar-brand">
                <Link to="/">
                    <img
                        src={`${process.env.PUBLIC_URL}/logo.png`}
                        alt="LCZ logo"
                        className="navbar-logo"
                        onError={(e) => {
                            console.error('Logo failed to load');
                            e.currentTarget.style.display = 'none';
                        }}
                    />
                    <span className="brand-text">Let's Change Zambia</span>
                </Link>
            </div>
            <ul className="navbar-links">
                <li>
                    <Link to="/">Home</Link>
                </li>
                <li>
                    <Link to="/about" className="nav-button">About Us</Link>
                </li>
                <li>
                    <Link to="/projects" className="nav-button">Projects</Link>
                </li>
                <li>
                    <Link to="/resources" className="nav-button">Resource Library</Link>
                </li>
                <li>
                    <Link to="/donate">Donate</Link>
                </li>
                <li>
                    <Link to="/contact" className="nav-button">Contact</Link>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;